/**
 * @import { AerialPlotResponse } from "./types"
 * @import { GduDataForTrials, ProtocolWeatherDataExcel } from "./types/weatherDataTypes"
 */

const aerialPlotApi = process.env.aerialPlotConnections.aerialPlotApi.baseUrl;

export function updateWeatherData(dateRange, clientId, accessToken) {
	return fetch(
		aerialPlotApi +
			"api/v1/WeatherData/UpdateWeatherData?startDate=" +
			dateRange.startDate +
			"&endDate=" +
			dateRange.endDate +
			"&clientId=" +
			clientId,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => res.json())
		.then((data) => data);
}

export function getGDUForTrial(trialId, clientId, forSincePlantingDates, accessToken) {
	return fetch(
		aerialPlotApi +
			"api/v1/WeatherData/GrowingDegreeUnits?trialId=" +
			trialId +
			"&clientId=" +
			clientId +
			"&forSincePlantingDates=" +
			forSincePlantingDates,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function getCurrentGDUForTrial(trialId, clientId, accessToken) {
	return fetch(
		aerialPlotApi + "api/v1/WeatherData/GrowingDegreeUnitsCurrent?trialId=" + trialId + "&clientId=" + clientId,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function getGDUForTrialHistorical(trialId, clientId, accessToken) {
	return fetch(
		aerialPlotApi + "api/v1/WeatherData/GrowingDegreeUnitsHistorical?trialId=" + trialId + "&clientId=" + clientId,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function validateWeatherData(trialId, clientId, forStartAndEndDates, accessToken, forSincePlanting) {
	return fetch(aerialPlotApi + "api/v1/WeatherData/ValidateWeatherData?trialId=" + trialId + "&clientId=" + clientId, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then(() => {
			return forSincePlanting
				? getCurrentGDUForTrial(trialId, clientId, accessToken)
				: getGDUForTrial(trialId, clientId, forStartAndEndDates, accessToken);
		});
}

export function getHistoricalWeatherData(trialId, clientId, accessToken) {
	return fetch(
		aerialPlotApi + "api/v1/WeatherData/GetHistoricalWeatherData?trialId=" + trialId + "&clientId=" + clientId,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function getTrialDailyWeather(trialId, clientId, accessToken) {
	return fetch(aerialPlotApi + "api/v1/WeatherData/GetTrialDailyWeather?trialId=" + trialId + "&clientId=" + clientId, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function createHistoricalWeatherData(trialId, clientId, accessToken) {
	return fetch(
		aerialPlotApi + "api/v1/WeatherData/CreateHistoricalWeatherData?trialId=" + trialId + "&clientId=" + clientId,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function updateHistoricalWeatherData(dateRange, clientId, accessToken) {
	return fetch(
		aerialPlotApi +
			"api/v1/WeatherData/UpdateHistoricalWeatherData?startDate=" +
			dateRange.startDate +
			"&endDate=" +
			dateRange.endDate +
			"&clientId=" +
			clientId,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => res.json())
		.then((data) => data);
}

export function inspectWeatherData(weatherDataCsv, newWeatherDataSetsVm, clientId, accessToken) {
	const weatherDataSetsFormData = new FormData();
	let datasetIndex = 0;

	if (newWeatherDataSetsVm.length > 0) {
		newWeatherDataSetsVm.splice(newWeatherDataSetsVm.length - 1, 1);
	}

	for (const name in newWeatherDataSetsVm) {
		let val = newWeatherDataSetsVm[name] === "" ? null : newWeatherDataSetsVm[name];
		for (const t in val) {
			let v = val[t] === "" ? null : val[t];
			if (v) {
				weatherDataSetsFormData.set(t, v);
			}
		}
		if (typeof val !== "object") {
			weatherDataSetsFormData.set(name, val);
		}
	}

	weatherDataSetsFormData.append("weatherDataCsv", weatherDataCsv, weatherDataCsv.name);

	for (const newWeatherDataVm of newWeatherDataSetsVm) {
		weatherDataSetsFormData.append(`WeatherDataSets[${datasetIndex}].weatherDataset.Day`, newWeatherDataVm.Day);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.DailyHigh`,
			newWeatherDataVm.DailyHigh,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.DailyLow`,
			newWeatherDataVm.DailyLow,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.Precipitation`,
			newWeatherDataVm.Precipitation,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.WindSpeed`,
			newWeatherDataVm.WindSpeed,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.WindSpeedMean`,
			newWeatherDataVm.WindSpeedMean,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.Temperature`,
			newWeatherDataVm.Temperature,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.Humidity`,
			newWeatherDataVm.Humidity,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.SolarEnergy`,
			newWeatherDataVm.SolarEnergy === undefined ? "" : newWeatherDataVm.SolarEnergy,
		);
		weatherDataSetsFormData.append(
			`WeatherDataSets[${datasetIndex}].weatherDataset.SolarRadiation`,
			newWeatherDataVm.SolarRadiation === undefined ? "" : newWeatherDataVm.SolarRadiation,
		);
		datasetIndex = datasetIndex + 1;
	}

	return fetch(aerialPlotApi + "api/v1/WeatherData/InspectWeatherData", {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
		body: weatherDataSetsFormData,
	})
		.then((res) => res.json())
		.then((data) => data);
}

/**
 * POST api/v1/WeatherData/GetGduDataForTrials. Returns the whole response.
 *
 * @param {string[]} trials trial ids
 * @param {string} currentClientId
 * @param {string} accessToken
 * @returns {Promise<AerialPlotResponse<GduDataForTrials>>}
 */
export function getGduDataForTrials(trials, currentClientId, accessToken) {
	return fetch(
		`${process.env.aerialPlotConnections.aerialPlotApi.baseUrl}api/v1/WeatherData/GetGduDataForTrials?clientId=${currentClientId}`,
		{
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify(trials),
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function generateWeatherDataExcel(trialId, currentDateTimeString, clientId, accessToken) {
	return fetch(
		`${process.env.aerialPlotConnections.aerialPlotApi.baseUrl}api/v1/WeatherData/GenerateTrialWeatherDataExcel?trialId=${trialId}&currentDateTimeString=${currentDateTimeString}&clientId=${clientId}`,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => res.json())
		.then((data) => data);
}

/**
 * POST api/v1/WeatherData/GenerateProtocolWeatherDataExcel. Returns `data` only. clientName is
 * unused by the server.
 *
 * @param {string[]} trials trial ids
 * @param {string} clientId
 * @param {string} clientName
 * @param {string} currentDateTimeString
 * @param {string} accessToken
 * @returns {Promise<ProtocolWeatherDataExcel>}
 */
export function generateProtocolWeatherDataExcel(trials, clientId, clientName, currentDateTimeString, accessToken) {
	return fetch(
		`${process.env.aerialPlotConnections.aerialPlotApi.baseUrl}api/v1/WeatherData/GenerateProtocolWeatherDataExcel?clientId=${clientId}&clientName=${clientName}&currentDateTimeString=${currentDateTimeString}`,
		{
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify(trials),
		},
	)
		.then((res) => res.json())
		.then((data) => data.data);
}

export async function fetchGDUForTrial(trialId, clientId, forSincePlantingDates, accessToken) {
	const res = await fetch(
		aerialPlotApi +
			"api/v1/WeatherData/GrowingDegreeUnits?trialId=" +
			trialId +
			"&clientId=" +
			clientId +
			"&forSincePlantingDates=" +
			forSincePlantingDates,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	if (!res.ok) {
		throw new Error("failed to fetch GDUs for trial");
	}

	const data = await res.json();
	return data.data;
}

export async function fetchCurrentGDUForTrial(trialId, clientId, accessToken) {
	const res = await fetch(
		aerialPlotApi + "api/v1/WeatherData/GrowingDegreeUnitsCurrent?trialId=" + trialId + "&clientId=" + clientId,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	if (!res.ok) {
		throw new Error("failed to fetch current GDUs for trial");
	}

	const data = await res.json();
	return data.data;
}

// FIXME: why is this two endpoints??
export async function validateWeatherDataAsync(trialId, clientId, forStartAndEndDates, accessToken, forSincePlanting) {
	const res = await fetch(
		aerialPlotApi + "api/v1/WeatherData/ValidateWeatherData?trialId=" + trialId + "&clientId=" + clientId,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	if (!res.ok) {
		throw new Error("failed to validate weather data");
	}

	if (forSincePlanting) {
		return await fetchCurrentGDUForTrial(trialId, clientId, accessToken);
	} else {
		return await fetchGDUForTrial(trialId, clientId, forStartAndEndDates, accessToken);
	}
}
